import { render, staticRenderFns } from "./AppDownloads.vue?vue&type=template&id=3342e300&scoped=true&"
import script from "./AppDownloads.vue?vue&type=script&lang=ts&"
export * from "./AppDownloads.vue?vue&type=script&lang=ts&"
import style0 from "./AppDownloads.vue?vue&type=style&index=0&id=3342e300&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3342e300",
  null
  
)

export default component.exports